/* eslint-disable indent */
import {
    ActiveIngredientFilterStatisticsCommand,
    BrandFilterStatisticsCommand,
    Command,
    ConditionsFilterStatisticsCommand,
    TreatmentFormFilterStatisticsCommand,
    DrugClassFilterStatisticCommand,
    PriceFilterStatisticsCommand,
    ProductTypeFilterStatisticsCommand,
    ReviewFilterStatisticsCommand,
    SmokeFilterStatisticsCommand,
} from '../../commands';

export class FilterStatisticsFactory {
    static createCommand(filterType: string): Command {
        switch (filterType) {
            case 'filter':
                return new SmokeFilterStatisticsCommand(filterType);
            case 'activeIngredient':
                return new ActiveIngredientFilterStatisticsCommand(filterType);
            case 'brand':
                return new BrandFilterStatisticsCommand(filterType);
            case 'conditions':
                return new ConditionsFilterStatisticsCommand(filterType);
            case 'treatmentForm':
                return new TreatmentFormFilterStatisticsCommand(filterType);
            case 'drugClass':
                return new DrugClassFilterStatisticCommand(filterType);
            case 'price':
                return new PriceFilterStatisticsCommand(filterType);
            case 'productType':
                return new ProductTypeFilterStatisticsCommand(filterType);
            case 'review':
                return new ReviewFilterStatisticsCommand(filterType);
            default:
                throw new Error(`Invalid filter command type: ${filterType}`);
        }
    }
}
